import Dialog from '@material-ui/core/Dialog';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { HintField, InputField, LabelField, MyCheckbox, SelectField } from 'components';
import InfoTooltip from 'components/InfoTooltip';
import { DateTimePickerField } from 'components/DateTime/DateTimePicker';
import { getDateFormat, getDateFormatForDatePicket, maskDate } from 'helper';
import AddNewTag from 'pages/Members/MemberDetails/AddNewTag';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { getOrganizationInfoFromLocalStorage } from 'utils/functions';
import ClassUploadCoverImage from './ClassUploadCoverImage';
import Wysiwyg from './Wysiwyg';
import { fontConfig } from "theme/fontConfig";

const ClassInfo = ({ formik,coverImage,setCoverImage,handleOpenCoverImage,croppedImage }) => {
  const orgDetails = getOrganizationInfoFromLocalStorage();
  const [maxDate, setMaxDate] = useState('');
  const [openTag, setOpenTag] = useState(false);
  const [openAccountTag, setOpenAccountTag] = useState(false);
  const dateMask = maskDate();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(getDateFormatForDatePicket());

  useEffect(() => {
    // const currentDate = new Date();
    // const maxDate = new Date(
    //   currentDate.getFullYear() + 100,
    //   currentDate.getMonth(),
    //   currentDate.getDate()
    // );
    // setMaxDate(maxDate.toISOString().slice(0, 10));

    const maxDate = new Date();
    const maximumDate = maxDate.setFullYear(maxDate.getFullYear() + 100);
    setMaxDate(maximumDate);
  }, []);

  const minDate = new Date();

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }

  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }



  const generateYearsHandler = () => {
    const currentYear = new Date().getFullYear();
    const yearsList = [];
    for (let i = 0; i <= 2; i++) {
      const year = currentYear + i;
      yearsList.push(year.toString());
      if(i < 2) {
        yearsList.push(`${year}-${year + 1}`);
      }
    }
    return yearsList;
  }
  

  return (
    <>
      <Row>
        <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={true}
            {...{
              formik,
              title: 'Class Name',
              name: 'class_name',
              placeholder: 'Class Name',
              checkValidation: true,
            }}
            value={formik.values?.class_name}
            handleChange={(e) => {
              formik.setFieldValue('class_name', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.class_name === '') {
                e.preventDefault();
              }
            }}
            maxLength={30}
          />
        </Col>
        <Col className="col-sm-6">
            <SelectField
              titleStyle={{
                fontFamily: fontConfig.GeneralSelectFieldFont.family,
                fontWeight: '400',
                fontSize: '12px',
                lineHeight: '18px',
                color: '#4F4F4F',
              }}
              {...{
                formik,
                title: 'Year',
                name: 'year',
                items: generateYearsHandler(),
                value: formik.values.year,
                placeholder: 'year',
                checkValidation: true,
              }}
              onClick={(data) => {
                formik.setFieldValue('year', data)
              }}
            />
          {/* <InputField
            titleStyle={{
              fontFamily: 'Poppins',
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={true}
            {...{
              formik,
              title: 'Year',
              name: 'year',
              placeholder: '2023',
              checkValidation: true,
            }}
            value={formik.values?.year}
            handleChange={(e) => {
              formik.setFieldValue('year', e.target.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
          /> */}
        </Col>
      </Row>
      <Row className="align-items-baseline">
        <Col className="col-sm-6" style={{ marginTop: '40px' }}>
          <LabelField 
            title={'Registration Starts'} 
            mandatory 
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
          />
          <div className="form-group fv-plugins-icon-container mb-0">
            <DatePicker
              isClearable
              showIcon
              placeholderText={getDateFormat()}
              dateFormat={getDateFormatForDatePicket()}
              selected={
                formik.values?.registration_starts &&
                convertUTCToLocalDate(formik.values?.registration_starts)
              }
              onChange={(e) => {
                if (formik.values?.registration_ends && e > formik.values?.registration_ends) {
                  toastr.info('Validation', 'Registration Starts date should be less than Registration Ends date');
                  return;
                }
                formik.setFieldValue(`registration_starts`, e);
                convertLocalToUTCDate(e, `registration_starts`);
              }}
              minDate={minDate}
              customInput={
                <MaskedInput
                  pipe={autoCorrectedDatePipe}
                  mask={dateMask}
                  keepCharPositions={true}
                  guide={true}
                  className={`form-control form-control-solid ${formik.touched?.registration_starts && formik.errors?.registration_starts ? 'is-invalid' : ''}`}
                />
              }
            />
            {formik.touched?.registration_starts && formik.errors?.registration_starts && (
              <HintField error={formik.errors.registration_starts} />
            )}
          </div>
        </Col>
        <Col className="col-sm-6" style={{ marginTop: '40px' }}>
          <DateTimePickerField
            mandatory={true}
            {...{
              formik,
              title: 'Registration Ends',
              name: 'registration_ends',
            }}
            checkValidation={true}
            placeholderText={getDateFormat()}
            dateFormat={getDateFormatForDatePicket()} 
            selected={
              formik.values?.registration_ends &&
              convertUTCToLocalDate(formik.values?.registration_ends)
            }
            onChange={(e) => {
              formik.setFieldValue(`registration_ends`, e);
              convertLocalToUTCDate(e, `registration_ends`);
            }}
            alwaysAvailable={true}
            checkAvailableHandler={() => {
              if (!formik.values?.alwaysAvailable) {
                formik.setFieldValue('registration_ends', null);
              }
              formik.setFieldValue(
                'alwaysAvailable',
                !formik.values?.alwaysAvailable
              );
            }}
            disabled={
              !formik.values?.registration_starts ||
              formik.values?.alwaysAvailable
            }
            // maxDate={maxDate}
            minDate={new Date(formik.values?.registration_starts) || minDate}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: '2px' }}>
        <Col className="col-sm-5 d-flex align-items-center" style={!orgDetails?.memberPortal ? { opacity: "0.5", cursor: "not-allowed"} : {}}>
          <MyCheckbox
            title="Allow non-member to register"
            checked={formik.values?.allow_non_members_register}
            handlechange={() => {
              formik.setFieldValue(
                'allow_non_members_register',
                !formik.values?.allow_non_members_register
              );
            }}
            disabled={!orgDetails?.memberPortal}
          />
        </Col>
        {/* <Col className="col-sm-5 d-flex align-items-center">
          <MyCheckbox
            title="Allow Waiting-List"
            checked={formik.values?.allow_waiting_list}
            handlechange={() => {
              formik.setFieldValue(
                'allow_waiting_list',
                !formik.values?.allow_waiting_list
              );
            }}
          />
        </Col> */}
      </Row>
      <Row>
        <Col className="col-sm-12" style={{ marginTop: '40px' }}>
          <LabelField
            title="Description"
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
          />
          <Wysiwyg formik={formik} />
        </Col>
      </Row>
      <Row>
        <Col className="col-sm-12" style={{ marginTop: '40px' }}>
          <LabelField
            title="Upload Cover Image (Max allowed is 5MB) (Min Image Dimension: 800x800)"
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
          />
          <ClassUploadCoverImage
            coverImageFile={coverImage?.name}
            handleOpenCoverImage={handleOpenCoverImage}
            croppedImage={croppedImage}
          />
        </Col>
      </Row>
      <hr style={{ marginTop: '40px' }} />
      <Row style={{ marginBottom: '20px' }}>
        <Col className="col-sm-12">
          <div className="d-flex" style={{ gap: '6px', alignItems: 'center', marginBottom: '8px' }}>
            <label style={{ fontFamily: fontConfig.SchoolClassInfoTextFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>
              Add Contact Tags
            </label>
            <InfoTooltip text='Automatically add selected tags to a contact after class registration is submitted. Example: Add a "Sunday School 2026" tag when someone registers to the class.' />
          </div>
          <div className="event_tags">
            {formik.values?.tags?.length > 0 && [...formik.values.tags].sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase())).map((tag) => (
              <span className="event_tag" key={tag}>
                {tag}
                <span
                  style={{ marginLeft: '5px', fontSize: '12px', fontWeight: '400', cursor: 'pointer' }}
                  onClick={() => {
                    formik.setFieldValue('tags', formik.values.tags.filter((t) => t !== tag));
                  }}
                >
                  x
                </span>
              </span>
            ))}
            <div className="event_add-tag">
              <span
                style={{ color: '#B5B5C3', fontFamily: fontConfig.SchoolClassInfoTextFont.family, fontWeight: '500', fontSize: '13px', textAlign: 'center', cursor: 'pointer' }}
                onClick={() => setOpenTag(true)}
              >
                <strong>+</strong> Add a tag
              </span>
            </div>
          </div>
        </Col>
      </Row>
      <div className="tag_modal">
        <Dialog
          open={openTag}
          onClose={() => setOpenTag(false)}
          PaperProps={{ style: { background: '#fff', borderRadius: '10px' } }}
        >
          <AddNewTag
            setOpenTag={setOpenTag}
            openTag={openTag}
            addTagHandler={(tag) => {
              formik.setFieldValue('tags', [...(formik.values?.tags || []), tag]);
            }}
            deleteTagHandler={(tag) => {
              formik.setFieldValue('tags', (formik.values?.tags || []).filter((t) => t !== tag));
            }}
            selectedUserTag={formik.values?.tags || []}
            type="event"
            apiType="contact"
          />
        </Dialog>
      </div>
      <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
        <Col className="col-sm-12">
          <div className="d-flex" style={{ gap: '6px', alignItems: 'center', marginBottom: '8px' }}>
            <label style={{ fontFamily: fontConfig.SchoolClassInfoTextFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>
              Add Account Tags
            </label>
            <InfoTooltip text='Automatically add selected tags to an account after class registration is submitted. Example: Add a "Sunday School 2026" tag to the account when someone registers to the class.' />
          </div>
          <div className="event_tags">
            {formik.values?.accountTags?.length > 0 && [...formik.values.accountTags].sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase())).map((tag) => (
              <span className="event_tag" key={tag}>
                {tag}
                <span
                  style={{ marginLeft: '5px', fontSize: '12px', fontWeight: '400', cursor: 'pointer' }}
                  onClick={() => {
                    formik.setFieldValue('accountTags', formik.values.accountTags.filter((t) => t !== tag));
                  }}
                >
                  x
                </span>
              </span>
            ))}
            <div className="event_add-tag">
              <span
                style={{ color: '#B5B5C3', fontFamily: fontConfig.SchoolClassInfoTextFont.family, fontWeight: '500', fontSize: '13px', textAlign: 'center', cursor: 'pointer' }}
                onClick={() => setOpenAccountTag(true)}
              >
                <strong>+</strong> Add a tag
              </span>
            </div>
          </div>
        </Col>
      </Row>
      <div className="tag_modal">
        <Dialog
          open={openAccountTag}
          onClose={() => setOpenAccountTag(false)}
          PaperProps={{ style: { background: '#fff', borderRadius: '10px' } }}
        >
          <AddNewTag
            setOpenTag={setOpenAccountTag}
            openTag={openAccountTag}
            addTagHandler={(tag) => {
              formik.setFieldValue('accountTags', [...(formik.values?.accountTags || []), tag]);
            }}
            deleteTagHandler={(tag) => {
              formik.setFieldValue('accountTags', (formik.values?.accountTags || []).filter((t) => t !== tag));
            }}
            selectedUserTag={formik.values?.accountTags || []}
            type="event"
            apiType="account"
          />
        </Dialog>
      </div>
    </>
  );
};

export default ClassInfo;
